module.exports = __webpack_public_path__ + "static/media/fundriver.050a51c9.svg";